import { CopyAll } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ActionsItemProps } from './actions'

export const DuplicateOrder = ({ order, disabled }: ActionsItemProps) => {
  const navigation = useNavigate()
  const handleClick = () => {
    // setModalIsOpen(true)
    // setProposalId(order.proposalId)
    navigation(`${order.proposalId}/duplicate`)
  }

  return (
    <>
      <MenuItem onClick={handleClick} disableRipple disabled={disabled}>
        <CopyAll />
        Duplicar
      </MenuItem>
    </>
  )
}
